<template>
  <div class="mx-6 bg-white">
    <div class="grid grid-cols-1 sm:grid-cols-3">
      <div class="col-span-2">
        <p
          class="text-[#1F618D] text-3xl font-medium capitalize font-['Inder'] py-2 px-3"
        >
          {{ detail.ten_game }}
        </p>
        <div class="px-3" v-html="detail.mota"></div>
        <div class="p-3 border-y border-[#A7A7A7] mt-2">
          <p class="grid grid-cols-3">
            <b class="text-[#1A5276] font-extrabold">Tài khoản : </b>
            <span class="text-brown text-black text-lg font-normal">{{
              detail.tai_khoan_game
            }}</span>
          </p>
          <p class="py-2 grid grid-cols-3">
            <b class="text-[#1A5276] font-extrabold">Mật khẩu : </b>
            <span class="text-brown text-black text-lg font-normal">{{
              detail.password_game
            }}</span>
          </p>
        </div>
        <p class="text-red-500 p-3 text-lg font-normal">
          <b>Lưu ý: </b>{{ detail.notes }}
        </p>
      </div>

      <div class="flex-col items-center p-5">
        <img
          class="w-full aspect-video min-h-[200px] max-h-[400px] border border-black p-1"
          :src="'/' + isImagePath(detail.hinh)"
          alt="Product Image"
        />
      </div>
    </div>
  </div>

  <div
    class="px-6 grid grid-cols-1 md:grid-cols-2 gap-4 mt-3 mb-7 md:mb-20 md:mt-5"
  >
    <div class="p-0">
      <div class="container-thanhtoan frame_layout2 border border-black">
        <div class="p-5 bg-white">
          <div class="mb-4">
            <b class="text-black text-lg sm:text-xl font-medium"
              >THÔNG TIN ĐƠN HÀNG</b
            >
          </div>
          <div class="flex flex-col gap-2">
            <div class="flex">
              <div class="w-1/2">
                <div class="form-group">
                  <label class="text-black text-lg font-normal"
                    >Mã đơn hàng:</label
                  >
                </div>
              </div>
              <div class="w-1/2">
                <div class="form-group">
                  <label class="text-black"
                    ><b>#{{ detail.id }}</b></label
                  >
                </div>
              </div>
            </div>

            <div class="flex">
              <div class="w-1/2">
                <div class="form-group">
                  <label class="text-black text-lg font-[Inder] font-normal"
                    >Thành tiền sản phẩm:</label
                  >
                </div>
              </div>
              <div class="w-1/2">
                <div class="form-group">
                  <label
                    class="text-[#D4AC0D] font-normal text-lg font-[Inder] sm:text-xl"
                    >{{ formatCurrency(detail.gia_dh) }}</label
                  >
                </div>
              </div>
            </div>

            <div class="flex">
              <div class="w-1/2">
                <div class="form-group">
                  <label class="text-black text-lg font-[Inder] font-normal"
                    >Ngày tạo:</label
                  >
                </div>
              </div>
              <div class="w-1/2">
                <div class="form-group">
                  <label class="text-[#006C45] text-lg font-[Inder]">{{
                    formatDate(detail.created_at)
                  }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from 'date-fns'
export default {
  props: ['detail'],
  methods: {
    formatDate(timestamp) {
      return format(new Date(timestamp), 'yyyy-MM-dd HH:mm:ss')
    },
    isImagePath(path) {
      const imagePathPrefix = 'assets/images'
      const check = path.includes(imagePathPrefix)
      if (check) {
        return path
      }
      return 'storage/' + path
    },
    formatCurrency(value) {
      return new Intl.NumberFormat('vi-VN', {
        style: 'currency',
        currency: 'VND',
      }).format(value)
    },
  },
}
</script>
